// frontend/src/components/account/ProfileHeader.jsx
import { Card, Tag, Typography } from "antd";

const { Title, Text } = Typography;

const ProfileHeader = ({ profile }) => {
  return (
    <Card style={{ marginBottom: "24px", borderRadius: "12px", border: "1px solid #e8e8e8" }}>
      <div style={{ marginBottom: "16px" }}>
        <Tag
          style={{
            borderRadius: "16px",
            padding: "4px 12px",
            fontSize: "12px",
            fontWeight: "500",
            marginLeft: "-24px",
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            color: "#ffffff",
            background: "#6DB33F",
            borderColor: "#6DB33F",
          }}
        >
          Member since {new Date(profile?.createdAt).getFullYear() || "2025"}
        </Tag>
      </div>

      {["active", "trial", "trialing"].includes(
        (profile?.subscriptionStatus || "").toLowerCase()
      ) && (
        <>
          <Title level={4} style={{ color: "#333", margin: "16px 0 8px 0" }}>
            Monthly Plan
            {profile?.subscriptionCancelAtPeriodEnd ? (
              <Tag
                style={{
                  marginLeft: 8,
                  color: "#6DB33F",
                  background: "#f3faf0",
                  borderColor: "#6DB33F",
                }}
              >
                Cancels at period end
              </Tag>
            ) : null}
          </Title>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div style={{ width: "32px", height: "20px", background: "linear-gradient(45deg, #ff4444, #ff8800)", borderRadius: "4px", position: "relative" }}>
              <div style={{ position: "absolute", top: "50%", left: "6px", transform: "translateY(-50%)", width: "20px", height: "12px", backgroundColor: "#ffaa00", borderRadius: "2px" }} />
            </div>
            <Text style={{ color: "#333", fontSize: "16px", fontFamily: "monospace" }}>
              •••• •••• •••• {profile?.lastFourDigits}
            </Text>
          </div>
        </>
      )}
    </Card>
  );
};

export default ProfileHeader;